<form [formGroup]="appTranslated">
  <div class="grid grid-cols-2 gap-6">
    <xena-input value={{app.name}}
      label="App name"
      i18n-label="@@translateApp_translations_name"
      tabindex="-1"
      readonly>
    </xena-input>
    <xena-input formControlName="name" *ngIf="selectedCulture"
      label="App name"
      i18n-label="@@translateApp_translations_name"
      [readonly]="isReadonly">
    </xena-input>
    <div *ngIf="!selectedCulture"></div>

    <xena-input value={{app.description}}
      label="Short description"
      i18n-label="@@translateApp_translations_description"
      tabindex="-1"
      readonly>
    </xena-input>
    <xena-input formControlName="description" *ngIf="selectedCulture"
      label="Short description"
      i18n-label="@@translateApp_translations_description"
      [readonly]="isReadonly">
    </xena-input>
    <div *ngIf="!selectedCulture"></div>

    <xena-textarea value={{app.details}}
      label="Long description"
      i18n-label="@@translateApp_translations_details"
      rows="10"
      tabindex="-1"
      readonly>
    </xena-textarea>
    <xena-textarea formControlName="details" *ngIf="selectedCulture"
      label="Long description"
      i18n-label="@@translateApp_translations_Details"
      help-text="Use Markdown to style the text"
      i18n-help-text="@@translateApp_translations_useMarkdown_helpText"
      rows="10"
      [readonly]="isReadonly">
    </xena-textarea>
    <div *ngIf="!selectedCulture"></div>

    <xena-textarea value={{app.termsMarkdown}}
      label="Terms of use"
      i18n-label="@@translateApp_translations_termsOfUse"
      rows="10"
      tabindex="-1"
      readonly>
    </xena-textarea>
    <xena-textarea formControlName="termsMarkdown" *ngIf="selectedCulture"
      label="Terms of use"
      i18n-label="@@translateApp_translations_termsOfUse"
      help-text="Use Markdown to style the text"
      i18n-help-text="@@translateApp_translations_useMarkdown_helpText"
      rows="10"
      [readonly]="isReadonly">
    </xena-textarea>
    <div *ngIf="!selectedCulture"></div>
  </div>
</form>
